import { LOCALE__PATH, LOCALE__REGEXP } from './constants';

export const PARAMS = {
  Locale: {
    path: LOCALE__PATH,
    regexp: LOCALE__REGEXP,
  },
};
